<script lang="ts">
	import { onMount } from 'svelte'

	import fetchy from 'shared/fetchy'
	import { storefront_api2_prefix } from 'shared/var'
	import ErrorMessage from 'component/ErrorMessage.svelte'
	import promise_in_flight_store from 'shared/promise_in_flight_store'
	import url from 'shared/url_tag'
	import assert from 'shared/assert'
	const api2_fetch = fetchy(storefront_api2_prefix)

	export let email: string = ``
	export let id: string = ``
	export let waitlist_ref: undefined | number = undefined
	export let waitlist_is_full: undefined | boolean = undefined

	const from_waitlist_email = !!(new URLSearchParams(document.location.search).get(`from_waitlist_email`))

	let signed_up = false
	let request: undefined | Promise<any>

	$: request_in_flight = promise_in_flight_store(request)
	$: disabled = $request_in_flight || !waitlist_ref

	onMount(async() => {
		if (waitlist_ref === undefined || waitlist_is_full === undefined) {
			assert(id)
			;({ waitlist_ref, is_full: waitlist_is_full } = await api2_fetch(`/stock_item_ref_to_waitlist_details/${ id }`))
		}

		assert(waitlist_ref)

		if (email) {
			try {
				signed_up = (await api2_fetch(url`waitlist/${ waitlist_ref }/email_is_on_list?email_address=${ email.trim() }`, {
					method: `GET`,
				})).is_on_list
			} catch (_) {}
		}
	})

	async function join_or_leave(joining: boolean) {
		request = api2_fetch(`/waitlist/${ waitlist_ref }/email`, {
			method: joining ? `POST` : `DELETE`,
			body: { email_address: email.trim() },
		})
		await request
		signed_up = joining
	}
	async function join() {
		await join_or_leave(true)
	}
	async function leave() {
		await join_or_leave(false)
	}
</script>

<div class="cont">
	{#if signed_up}
		You are on the waitlist.
		<button on:click|preventDefault={leave} {disabled}>Leave</button>
	{:else if waitlist_is_full}
		<div class="title">Sorry! This waitlist is full. Please check back at a later time.</div>
	{:else}
		{#if from_waitlist_email}
			<div class="title">Sorry! This item is already out of stock. Re-join the waitlist below.</div>
		{:else}
			<div class="title">Join the waitlist to be emailed when this product becomes available.</div>
		{/if}
		<form on:submit|preventDefault={join}>
			<input type="email" bind:value={email} placeholder="Email address" {disabled} />
			<button {disabled}>Join</button>
		</form>
	{/if}

	{#await request catch error}
		<ErrorMessage server_error_response={error} />
	{/await}
</div>

<style>
	.cont {
		max-width: 300px;
		padding: 5px;
		font-size: 14px;
	}

	.title {
		color: white;
		margin: 5px 0;
	}

	form {
		display: flex;
		align-items: center;
	}

	input {
		width: 100%;
	}

	input, button {
		padding: 10px 15px !important;
		line-height: 20px;
	}

	button {
		margin-left: 10px;
	}
</style>
